module.exports = __webpack_public_path__ + "img/transparent-white.486105b4.png";